import {
  // reason: this is the wrapped component which we will allow since this is the exported version
  // eslint-disable-next-line @dhl/dhl-ui/no-restricted-imports
  Table as MuiTable,
  type TableProps as MuiTableProps,
} from '@mui/material'

type TableProps = MuiTableProps & {
  isZebra?: boolean
}

/**
 * Table
 *
 * Demos:
 * - [Table](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/primitives-table--docs)
 *
 */

export const Table = ({ isZebra = true, ...props }: TableProps) => (
  <MuiTable className={`DhlTable--${isZebra ? 'zebra' : 'plain'}`} {...props} />
)
